import { targetEnv, sgBaseUrl } from '@fs/zion-config'

export const IS_PRODUCTION = targetEnv === 'prod' || sgBaseUrl?.includes('sg30p')
const IS_INTEGRATION = targetEnv === 'int' || sgBaseUrl?.includes('sg32i')
const IS_BETA = targetEnv === 'beta' || sgBaseUrl?.includes('sg31b')

export const SG_APP_PATH = (() => {
  if (IS_PRODUCTION) return 'https://sg30p0.familysearch.org'
  if (IS_INTEGRATION) return 'https://sg32i0.familysearch.org'
  return 'https://sg31b0.familysearch.org'
})()

export const sgEnvUrl = sgBaseUrl || SG_APP_PATH

const useHeadlessChat =
  typeof window !== 'undefined' && IS_BETA && new URLSearchParams(window.location.search).get('headless-chat') !== null

export const chatApiBase = useHeadlessChat ? '/service/fs-chat/headless/v2' : '/service/fs-chat/api/v2'

// This should match the version in package.json. It is shown in the blocked users page and sent in splunk logs.

export const chatVersion = '3.15.2'
